import { connect, MapDispatchToProps } from 'react-redux';
import { batchEditLicense } from '../../../actions/studio';
import { BatchEditLicense } from '../../../types/batchActions';
import { Props } from './LicenseBatchEdit';

export type StateProps = Pick<Props, never>;
export type DispatchProps = Pick<Props, 'batchEditLicense'>;
export type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = dispatch => ({
  batchEditLicense: (license: BatchEditLicense) => dispatch(batchEditLicense(license)),
});

export default connect(null, mapDispatchToProps);
